import { inject } from '@angular/core';
import { CapacitorService } from './services';
import { Routes } from '@angular/router';

export const routes: Routes = [

  // Logged In

  {
    path: '',
    canMatch: [() => inject(CapacitorService).checkRoute(true)],
    loadComponent: () => import('./pages/map/map.page').then(m => m.MapPage),
  },
  {
    path: '',
    canMatch: [() => inject(CapacitorService).checkRoute(false)],
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
  },

  // Public
  
  {
    path: 'login/:id',
    loadComponent: () => import('./www/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'invite/:id',
    loadComponent: () => import('./www/invite/invite.page').then(m => m.InvitePage)
  },
  {
    path: 'help',
    loadComponent: () => import('./www/help/help.page').then(m => m.HelpPage)
  },
  {
    path: 'press',
    loadComponent: () => import('./www/press/press.page').then(m => m.PressPage)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./www/privacy/privacy.page').then(m => m.PrivacyPage)
  },
  {
    path: 'terms',
    loadComponent: () => import('./www/terms/terms.page').then(m => m.TermsPage)
  },
  {
    matcher: (segments) => {
      const supported = ['en', 'nl', 'de', 'fr', 'it', 'es', 'pt'];
      const lang = segments[0]?.path;
      if (supported.includes(lang)) {
        return { consumed: [segments[0]] };
      }
      return null;
    },
    loadComponent: () => import('./www/index/index.page').then(m => m.IndexPage)
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./www/index/index.page').then(m => m.IndexPage)
  },

  // Redirects

  {
    path: '**',
    redirectTo: '/',
  }
];